import React from 'react';
import i18n from '../../../i18n';
import { getAuctionChartData, getSalesChartData } from '../../../models/auctions';
import { getUserChartData } from '../../../models/users';
import { getDashboardData, getDashboardAuctionsList } from '../../../models/dashboard';
import { getLoggedUser } from '../../../state/user';
import { Modal } from 'react-bootstrap';
import { MzadLoader } from '../../helpers/mzadLoader';
import { OrganizationAuctionItem } from './orgAucItem';

const user = getLoggedUser();

export class DashboardAuctionEvaluationData extends React.Component {
  constructor() {
    super();
    this.state = {
      show_active_list: false,
      aa_loading: false,
      auctions_list: [],
      first_panel: true,
      second_panel: true,
      third_panel: false,
      forth_panel: false,
      input: {},
      is_loading_1: false,
      is_loading_2: false,
      is_loading_3: false,
      is_loading_4: false,
      main_auctions: [],
      charity_auctions: [],
      auctions: {
        series: [0, 0, 0, 0, 0],
        options: {
          chart: {
            height: 350,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '70%',
              },
            },
          },
          labels: [
            i18n.t('active'),
            i18n.t('upcoming'),
            i18n.t('previous'),
            i18n.t('featured'),
            i18n.t('direct'),
          ],
          legend: {
            show: true,
            position: 'bottom',
          },
        },
      },
      charity: {
        series: [0, 0, 0, 0, 0],
        options: {
          chart: {
            height: 350,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '100%',
              },
            },
          },
          labels: ['Active', 'Upcoming', 'Previous', 'Featured', 'Direct'],
          legend: {
            show: true,
            position: 'bottom',
          },
        },
      },
      userData: 'monthly',
      daily: {},
      monthly: {},
      salesData: 'monthly',
      yearlySales: {},
      monthlySales: {},
      active_auctions: 0,
      active_bidders: 0,
      total_bidders: 0,
      total_bids: 0,
      maximum_bid_amount: 0,
      total_amount: 0,
      auction_in_bidding: 0,
      dd_loading: false,
      group: false,
      is_side_bar: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.loadDashboardData = this.loadDashboardData.bind(this);
    this.hideSideBar = this.hideSideBar.bind(this);
  }

  componentDidMount() {
    this.loadAuctionsData();
    this.loadCharityAuctionsData();
    this.loadUserChartData();
    this.loadSalesChartData();
    if (user.role === 'A' || user.role === 'M') {
      setInterval(this.loadDashboardData, 10000);
    }
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async loadDashboardData(data = false) {
    this.setState({ dd_loading: true });
    let { group, auction } = data;
    let input = this.state.input;
    input.group = typeof group !== 'undefined' ? group : input.group;
    input.auction = typeof auction !== 'undefined' ? auction : input.auction;
    if (typeof input.group === 'undefined') {
      this.setState({ dd_loading: false });
      return;
    }
    let response = await getDashboardData(input);
    if (response.success) {
      let { data } = response;
      this.setState({
        active_auctions: data.active_auctions,
        active_bidders: data.active_bidders,
        total_bidders: data.total_bidders,
        maximum_bid_amount: data.maximum_bid_amount,
        total_amount: data.total_amount,
        auction_in_bidding: data.auction_in_bidding,
        total_bids: data.total_bids,
      });
      this.setState({ dd_loading: false });
    }
  }

  async loadAuctionsData() {
    this.setState({ is_loading_1: true });
    let auctions = this.state.auctions;
    const response = await getAuctionChartData('main');
    let data = response.data;
    if (response) {
      auctions.series = [data.active, data.upcoming, data.previous, data.featured, data.direct];
      this.setState({
        is_loading_1: false,
        auctions,
        main_auctions: auctions.series,
      });
    }
  }

  async loadCharityAuctionsData() {
    this.setState({ is_loading_2: true });
    let charity = this.state.charity;
    const response = await getAuctionChartData('charity');
    let data = response.data;
    if (response) {
      charity.series = [data.active, data.upcoming, data.previous, data.featured, data.direct];
      this.setState({
        is_loading_2: false,
        charity,
        charity_auctions: charity.series,
      });
    }
  }

  async loadUserChartData() {
    this.setState({ is_loading_3: true });
    let daily = this.state.daily;
    let monthly = this.state.monthly;
    const response = await getUserChartData();
    let data = response.data;
    if (response) {
      this.setState({ is_loading_3: false });
      daily.options = {
        chart: { id: 'chart-userdata' },
        xaxis: {
          categories: data.dates,
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      };
      daily.series = [
        {
          name: 'Total Users',
          data: data.values,
        },
      ];

      monthly.options = {
        chart: { id: 'chart-userdata' },
        xaxis: {
          categories: data.months,
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      };
      monthly.series = [
        {
          name: 'Total Users',
          data: data.month_values,
        },
      ];

      this.setState({ daily, monthly });
    }
  }

  async loadSalesChartData() {
    this.setState({ is_loading_4: true });
    let yearly = this.state.yearlySales;
    let monthly = this.state.monthlySales;
    const response = await getSalesChartData();
    let data = response.data;
    if (response) {
      this.setState({ is_loading_4: false });
      yearly.options = {
        chart: { id: 'chart-salesdata' },
        xaxis: {
          categories: data.years,
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      };
      yearly.series = [
        {
          name: 'Total Sales',
          data: data.year_values,
        },
      ];

      monthly.options = {
        chart: { id: 'chart-salesdata' },
        xaxis: {
          categories: data.months,
          labels: {
            rotate: -45,
            rotateAlways: true,
          },
        },
      };
      monthly.series = [
        {
          name: 'Total Sales',
          data: data.month_values,
        },
      ];

      this.setState({ yearlySales: yearly, monthlySales: monthly });
    }
  }

  hideSideBar(is_side_bar) {
    this.setState({
      is_side_bar: is_side_bar,
    });
  }

  async getActiveAuctions() {
    this.setState({ show_active_list: true });
    this.setState({ aa_loading: true });
    let response = await getDashboardAuctionsList();
    if (response.success) {
      let auctions_list = response.data;
      this.setState({ auctions_list });
      this.setState({ aa_loading: false });
    } else {
      this.setState({ aa_loading: false });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div className="bg-white rounded-4 hide_div mb-3">
                <div className="p-4">
                  <div className="p-2 user-brd rounded-4">
                    <div className="grid_container d-flex flex-column gap-4">
                      <div
                        className="outer_round1 flex_container mb-1"
                        onClick={() => {
                          this.getActiveAuctions();
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="inner_round">
                          <span>{this.state.main_auctions[0] || 0}</span>
                        </div>
                        <div className=" outer_text lh20">
                          <span>{i18n.t('active')}</span>
                          {i18n.t('auctions')}
                        </div>
                      </div>
                      <div
                        className="outer_round2 flex_container"
                        onClick={() => {
                          window.location.href = '/auctions-list?type=upcoming';
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="inner_round">
                          <span>{this.state.main_auctions[1] || 0}</span>
                        </div>
                        <div className=" outer_text lh20">
                          <span>{i18n.t('upcoming')}</span>
                          {i18n.t('auctions')}
                        </div>
                      </div>
                      <div
                        className="outer_round3 flex_container"
                        onClick={() => {
                          window.location.href = '/auctions-list?type=previous';
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="inner_round">
                          <span>{this.state.main_auctions[2] || 0}</span>
                        </div>
                        <div className=" outer_text lh20">
                          <span>{i18n.t('previous')}</span>
                          {i18n.t('auctions')}
                        </div>
                      </div>
                      <div
                        className="outer_round4 flex_container"
                        onClick={() => {
                          window.location.href = '/auctions-list?type=featured';
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="inner_round">
                          <span>{this.state.main_auctions[3] || 0}</span>
                        </div>
                        <div className=" outer_text lh20">
                          <span>{i18n.t('featured')}</span>
                          {i18n.t('auctions')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <AuctionsChart
                main_auctions={this.state.main_auctions}
                data_panel={data_panel}
                is_loading={this.state.is_loading_1}
                auctions={this.state.auctions}
              /> */}
            </div>
          </div>
        </div>

        {this.state.show_active_list && (
          <Modal
            size="md"
            show={() => {
              this.setState({ show_active_list: true });
            }}
            onHide={() => {
              this.setState({ show_active_list: false });
            }}
            animation={true}
            dialogClassName="modal-60w"
            aria-labelledby="example-modal-sizes-title-lg"
            scrollable={true}
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">
                {i18n.t('active')} {i18n.t('auctions')}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <MzadLoader loading={this.state.aa_loading} />
              {!this.state.aa_loading && (
                <div>
                  <div className="container">
                    <div className="col-md-12">
                      <div className="panel panel-default">
                        <div className="panel-body">
                          <table className="table table-condensed table-striped">
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>{i18n.t('organization')}</th>
                                <th>{i18n.t('auctions')}</th>
                                <th>
                                  {i18n.t('expand')}/{i18n.t('collapse')}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.auctions_list.map((item, i) => {
                                return <OrganizationAuctionItem data={item} />;
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Modal.Body>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}
